export const tokenHeader = (accessToken) => ({
    headers: {
        Authorization: `Bearer ${accessToken}`,
    },
})